// Mirror of Shared/Calculators/Format.cs (Fmt). Kept byte-identical in output so
// server-rendered results match live results (no flash on hydration).

export function roundTo(v: number, places = 2): number {
  const f = Math.pow(10, places);
  // +EPSILON nudges values like 2.005 to round the way C# Math.Round(AwayFromZero) does.
  return Math.round((v + Number.EPSILON * Math.sign(v || 1)) * f) / f;
}

export function ceilUnits(v: number): number {
  return Math.ceil(roundTo(v, 6));
}

export function round(v: number, places = 2): number {
  return roundTo(v, places);
}

export function intStr(v: number): string {
  return Math.round(v).toLocaleString("en-US", { maximumFractionDigits: 0 });
}

export function dec(v: number, places = 2): string {
  const r = roundTo(v, places);
  // Trim trailing zeros, up to `places` decimals.
  return r.toLocaleString("en-US", { maximumFractionDigits: places, useGrouping: false });
}

export function usd(v: number): string {
  return "$" + Math.round(v).toLocaleString("en-US", { maximumFractionDigits: 0 });
}

export function usdRange(low: number, high: number): string {
  return usd(low) + "–" + usd(high);
}

export function plural(qty: number, singular: string, pluralForm: string): string {
  return Math.abs(qty - 1) < 1e-9 ? singular : pluralForm;
}

export function get(d: Record<string, number>, key: string): number {
  return key in d ? d[key] : 0;
}
